// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'face-sad-solid';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M20.63 4.37C18.386 2.122 15.69 1 12.5 1 9.31 1 6.615 2.123 4.37 4.37 2.122 6.614 1 9.31 1 12.5c0 3.19 1.123 5.885 3.37 8.13C6.614 22.878 9.31 24 12.5 24c3.19 0 5.885-1.123 8.13-3.37C22.878 18.386 24 15.69 24 12.5c0-3.19-1.123-5.885-3.37-8.13Zm-2.692 13.705-.328 1.19c-2.016-.833-3.703-1.25-5.063-1.25-1.406 0-3.14.417-5.155 1.25l-.328-1.19c2.11-.893 3.937-1.31 5.437-1.31 1.5 0 3.327.417 5.437 1.31Zm-8.11-4.87a.993.993 0 0 0 .282-.689V10.5L8.188 10v2.516c0 .246.094.492.281.689a.906.906 0 0 0 .657.295c.28 0 .514-.099.702-.295Zm6.703 0a.996.996 0 0 0 .281-.689V10l-1.922.5v2.016c0 .246.094.492.282.689a.932.932 0 0 0 1.359 0Z'
  />
);

export const viewBox = '0 0 25 25';
